import {appContainer} from "../contexts/app";
import Resource from "./resource";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState, validate} from "./hooks";

export default app => {
  const service = app.service("api/marker-type-categories");

  const MarkerTypeCategoryRecord = Resource(service, {
    account_id: "",
    name: ""
  });

  const validateMarkerTypeCategory = validate({
    name: "Marker type category name is required."
  });

  appContainer.MarkerTypeCategoryRecord = MarkerTypeCategoryRecord;
  app.set("MarkerTypeCategoryRecord", MarkerTypeCategoryRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateMarkerTypeCategory],
      update: [fromImmutable, validateMarkerTypeCategory],
      patch: [fromImmutable, validateMarkerTypeCategory],
      remove: []
    },

    after: {
      all: [toImmutable(MarkerTypeCategoryRecord)],
      find: [setListInState("markerTypeCategories")],
      get: [setInState("markerTypeCategories")],
      create: [setInState("markerTypeCategories")],
      update: [setInState("markerTypeCategories")],
      patch: [setInState("markerTypeCategories")],
      remove: [deleteInState("markerTypeCategories")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/marker-type-categories.js